import API from "./axios";

/**
 * Material Set master - reusable groups of materials priced as one.
 * applyToPo is the operation that matters: pick a set on a PO and its members
 * become lines, grouped at the master's LOCKED price.
 */
const materialSetApi = {
  paged:     (params = {})       => API.get("/material-sets/paged", { params }),
  active:    ()                  => API.get("/material-sets/active"),
  create:    (body)              => API.post("/material-sets", body),
  update:    (id, body)          => API.put(`/material-sets/${id}`, body),
  toggle:    (id)                => API.patch(`/material-sets/${id}/toggle-status`),
  delete:    (id)                => API.delete(`/material-sets/${id}`),
  applyToPo: (id, poId, setQty)  => API.post(`/material-sets/${id}/apply-to-po/${poId}`, { setQty }),
};

export default materialSetApi;
